import type { WorkflowDefinition } from "@/stores/workflowsStore";

export interface TokenRef {
  tokenAddress: string;
  chainId: number;
}

const ADDRESS_FIELDS = ["tokenAddress", "tokenIn", "tokenOut", "sellToken", "buyToken"] as const;

/**
 * Walk a workflow/template definition and collect unique {tokenAddress, chainId}
 * pairs from node payloads. Used to resolve token addresses mentioned in
 * free-form descriptions into symbol/logo badges via useSimTokensInfo.
 */
export function extractDefinitionTokenRefs(definition: WorkflowDefinition | undefined): TokenRef[] {
  const nodes = definition?.nodes as Record<string, { payload?: Record<string, unknown> }> | undefined;
  if (!nodes) return [];
  const seen = new Set<string>();
  const refs: TokenRef[] = [];
  for (const node of Object.values(nodes)) {
    const payload = node.payload;
    if (!payload) continue;
    const chainId = typeof payload.chainId === "number" ? payload.chainId : undefined;
    if (!chainId) continue;
    for (const field of ADDRESS_FIELDS) {
      const addr = payload[field];
      if (typeof addr !== "string" || !addr.startsWith("0x")) continue;
      const key = `${addr.toLowerCase()}:${chainId}`;
      if (seen.has(key)) continue;
      seen.add(key);
      refs.push({ tokenAddress: addr, chainId });
    }
  }
  return refs;
}
